import React, { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import html2pdf from "html2pdf.js";
import label from "../../labels/recommendationProcess_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import { getQualifiedCandidates } from "../../actions/recommendationProcessActions";

import { getYearList, getAdvertisementlistByYear } from "../../../common/actions/commonActions";


const QualifiedCandidates = () => {

  const pdfRef = useRef(null);

  const { register, handleSubmit, errors } = useForm(
    {
      mode: "onChange",
    }
  );

  let { qualifiedCandidateList } = useSelector(
    (state) => state.recommendationProcessReducer,
    shallowEqual
  );

  let { advertisementList, examList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );


  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [confirmClicked, setConfirmClicked] = useState(false);
  const [printFlag, setPrintFlag] = useState(true);
  const [selectedYear, setSelectedYear] = useState("");
  const [statisticalData, setStatisticalData] = useState([]);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0)
    dispatch(getYearList());
    setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (qualifiedCandidateList?.recommendedReportListDtos?.length > 0) {

      setStatisticalData(qualifiedCandidateList.recommendedReportListDtos);
    }
  }, [qualifiedCandidateList]);

  useEffect(() => {
    setPrintFlag(statisticalData.length === 0);
  }, [statisticalData]);

  const onAdvertisementChange = (ele) => {
    setSelectedAdvertNo(ele);
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    examList.length = 0;
    setStatisticalData([]);
    ele && dispatch(getExamslistByAdvertisementId(ele));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    setSelectedExam(ele);
    setSaveButtonFlag(false);
    setConfirmClicked(true);
    setPrintFlag(true);
    setReloadItem(!reloadItem);
    setStatisticalData([]);
  };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSaveButtonFlag(true);
    setConfirmClicked(false);
    setPrintFlag(true);
    setReloadItem(!reloadItem);
    examList.length = 0;
    setStatisticalData([]);
  };

  const onSubmit = () => {
    dispatch(getQualifiedCandidates(selectedAdvertNo, selectedExam));
    setReloadItem(!reloadItem);
  };




  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton()
    } else {

      let selectedValue = ele;
      setSelectedYear(selectedValue)
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0
      }
      if (examList) {
        examList.length = 0;
      }
      setStatisticalData([])
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
    }
  };
  const genPdf = () => {

    let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5>' + commonLabels.MPSC + '</h5><h5>' + qualifiedCandidateList.examName + '</h5><h5>' + label.QualifiedCandidates + '</h5></div>';
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;
    const examName = qualifiedCandidateList.examName;

    const options = {
      margin: [1, 0.4, 0.7, 0.4],
      filename: "QualifiedCandidates.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 2, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1.2;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');

          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = qualifiedCandidateList.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`QualifiedCandidates_${examName}.pdf`);
      });
  };

  const downloadPdf = () => {
    genPdf();
    setReloadItem(!reloadItem);
  };




  return (
    <div>
      {/* <h5> {label.QualifiedCandidates} </h5> */}
      <div className="row dashboardCards">
        <div className="col-md-12 ">
          <form name="importForm" encType="multipart/form-data">
            <div className="form-group importFromSection">
              <div className="row">
                <div className="form-group col-md-2">
                  <label className="float-left">
                    {commonLabels.selectYear}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedYear"
                    value={selectedYear}
                    // ref={register({ required: true })}
                    onChange={(e) => {
                      onSelectYear(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {yearList &&
                      yearList.length > 0 &&
                      yearList
                        .map((element, index) => (
                          <option>{element}</option>
                          // <option key={index} value={element.id}>
                          //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          // </option>
                        ))}
                  </select>
                  {_.get("selectedYear.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>
                <div className="form-group col-md-5">
                  <label className="float-left">
                    {commonLabels.SelectAdvertNo}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedAdvertiseNo"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onAdvertisementChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {allYearList &&
                      allYearList.length > 0 &&
                      allYearList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {`${element.advertisementNo}/${element.year} - ${element.name}`}
                          </option>
                        ))}
                  </select>
                  {_.get("selectedAdvertiseNo.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                </div>

                <div className="form-group col-md-4">
                  <label className="float-left">
                    {label.SelectExam}
                    <span className="errorText">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="selectedExam"
                    ref={register({ required: true })}
                    onChange={(e) => {
                      onExamChange(e.target.value);
                    }}
                  >
                    <option key={0} value="">
                      {commonLabels.COMBO_SELECT}
                    </option>
                    {
                      examList &&
                      examList.length > 0 &&
                      examList
                        .filter(
                          (element) =>
                            element.isDeleted == false &&
                            element.isActive === true
                        )
                        .map((element, index) => (
                          <option key={index} value={element.id}>
                            {element.name}
                          </option>
                        ))
                    }
                  </select>
                  {_.get("selectedExam.type", errors) === "required" && (
                    <p className="errorText float-left">
                      {commonLabels.MANDATORY_FIELD_MESSAGE}
                    </p>
                  )}
                </div>

              </div>

              <div className="row">
                <div className="form-group col-md-8">
                  {(session.roleName == 'superadmin' || session.roleName == 'secretary' || session.roleName == 'desk officer') &&
                    <>          <button
                      type="reset"
                      className="btn btn-secondary mr-2"
                      onClick={() => onCancelButton()}
                    >
                      {commonLabels.BUTTON_CANCEL}
                    </button>

                      <button
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={saveButtonFlag}
                        onClick={handleSubmit((e) => {
                          onSubmit(e);
                          setConfirmClicked(true);
                        })}
                      >
                        {commonLabels.BUTTON_VIEW}
                      </button>
                    </>}
                  {(session.roleName == 'superadmin' || session.roleName == 'secretary') && <button
                    type="button"
                    className="btn btn-primary mr-2"
                    disabled={printFlag || !confirmClicked}
                    onClick={() => {
                      downloadPdf();
                    }}
                  >
                    {commonLabels.BUTTON_PRINT}
                  </button>
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      {selectedExam && statisticalData && statisticalData.length > 0 && (
        <div ref={pdfRef} className="answerKeyTable" id="qualifiedCandidateList">
          <table className="table table-bordered text-center">
            <thead className="bold-label">
              <tr>
                <th></th>
                <th>{label.OPEN}</th>
                <th>{label.SC}</th>
                <th>{label.ST}</th>
                <th>{label.dtA}</th>
                <th>{label.ntB}</th>
                <th>{label.ntC}</th>
                <th>{label.ntD}</th>
                <th>{label.SBC}</th>
                <th>{label.SEBC}</th>
                <th>{label.EWS}</th>
                <th>{label.OBC}</th>
                <th><strong>{label.TOTAL}</strong></th>
              </tr>
            </thead>
            <tbody>
              {statisticalData.map((category, index) => (
                <tr key={category.category}>
                  <td>{category.category}</td>
                  <td>{category.subCategory.OPEN || 0}</td>
                  <td>{category.subCategory.SC || 0}</td>
                  <td>{category.subCategory.ST || 0}</td>
                  <td>{category.subCategory['DT-A'] || 0}</td>
                  <td>{category.subCategory['NT-B'] || 0}</td>
                  <td>{category.subCategory['NT-C'] || 0}</td>
                  <td>{category.subCategory['NT-D'] || 0}</td>
                  <td>{category.subCategory.SBC || 0}</td>
                  <td>{category.subCategory.SEBC || 0}</td>
                  <td>{category.subCategory.EWS || 0}</td>
                  <td>{category.subCategory.OBC || 0}</td>
                  <td><strong>{category.subCategory.TOTAL || 0}</strong></td>
                </tr>
              ))}

              <tr>
                <td><strong>TOTAL</strong></td>
                <td><strong>{qualifiedCandidateList.total.OPEN || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total.SC || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total.ST || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total['DT-A'] || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total['NT-B'] || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total['NT-C'] || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total['NT-D'] || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total.SBC || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total.SEBC || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total.EWS || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total.OBC || 0}</strong></td>
                <td><strong>{qualifiedCandidateList.total.TOTAL || 0}</strong></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default QualifiedCandidates;
